var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrentPreparationStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.570312C18.3513 0.570312 23.5 5.71904 23.5 12.0703C23.5 18.4216 18.3513 23.5703 12 23.5703C5.64873 23.5703 0.5 18.4216 0.5 12.0703C0.5 5.71904 5.64873 0.570312 12 0.570312Z",
    stroke: "#0085E9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0001,
    cy: 12.0719,
    r: 2.4,
    fill: "#0085E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentPreparationStatus);
export default __webpack_public_path__ + "static/media/current-preparation-status.082a5786.svg";
export { ForwardRef as ReactComponent };